import { useEffect, useState } from 'react';

import { getTableWorkerInstance, releaseTableWorkerInstance } from './helpers';

export function useTableWorker() {
  const [worker, setWorker] = useState<Worker | null>(null);

  useEffect(() => {
    let isMounted = true;

    getTableWorkerInstance().then((instance) => {
      if (isMounted) setWorker(instance);
    });

    return () => {
      isMounted = false;
      releaseTableWorkerInstance();
    };
  }, []);
  return worker;
}
